document.addEventListener("DOMContentLoaded", function () {

/**
 * Tab Navigation Custom Element
 * 
 * Usage:
 * <tab-navigation>
 *   <button class="tab-button tab-button--active" data-content="table-1" data-tab="header-1">Tab 1</button>
 *   <button class="tab-button" data-content="table-2" data-tab="header-2">Tab 2</button>
 * </tab-navigation>
 * 
 * Attributes on buttons:
 * - data-content: ID of the main content panel to show/hide (uses .is-active class)
 * - data-tab: ID of the secondary content (header) to show/hide (uses .is-active class)
 * - class="tab-button--active": Marks the initially active tab
 */
class TabNavigation extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.buttons = Array.from(this.querySelectorAll('.tab-button'));

    if (this.buttons.length === 0) {
      return;
    }

    // Find initially active button
    const activeButton = this.buttons.find(btn => btn.classList.contains('tab-button--active'));
    if (activeButton) {
      this.activeIndex = this.buttons.indexOf(activeButton);
    }

    this.bindEvents();
  }

  bindEvents() {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.selectTab(index);
      });
    });
  }

  selectTab(index) {
    // Early return if index is invalid or already active
    if (index < 0 || index >= this.buttons.length || index === this.activeIndex) {
      return;
    }

    const previousIndex = this.activeIndex;
    const previousButton = this.buttons[previousIndex];
    const newButton = this.buttons[index];

    // Deactivate previous tab
    previousButton.classList.remove('tab-button--active');
    this.deactivateContent(previousButton);

    // Activate new tab
    newButton.classList.add('tab-button--active');
    this.activateContent(newButton);

    // Update active index
    this.activeIndex = index;
  }

  activateContent(button) {
    const contentId = button.getAttribute('data-content');
    const tabId = button.getAttribute('data-tab');

    if (contentId) {
      const contentPanel = document.getElementById(contentId);
      if (contentPanel) {
        contentPanel.classList.add('is-active');
      }
    }

    if (tabId) {
      const tabPanel = document.getElementById(tabId);
      if (tabPanel) {
        tabPanel.classList.add('is-active');
      }
    }
  }

  deactivateContent(button) {
    const contentId = button.getAttribute('data-content');
    const tabId = button.getAttribute('data-tab');

    if (contentId) {
      const contentPanel = document.getElementById(contentId);
      if (contentPanel) {
        contentPanel.classList.remove('is-active');
      }
    }

    if (tabId) {
      const tabPanel = document.getElementById(tabId);
      if (tabPanel) {
        tabPanel.classList.remove('is-active');
      }
    }
  }
}

// Register the custom element
if (!customElements.get('tab-navigation')) {
  customElements.define('tab-navigation', TabNavigation);
}

});